import Modal from "./modal";
import ViewMessage from "./view-message";
import LinkInterceptCallback from "./link-intercept-callback";
import LinkResponseCallback from "./link-response-callback";

export default class ViewModal extends Modal {
  #linkInterceptCb;
  #linkResponseCb;
  #setContentCb;
  #$container;

  constructor(linkInterceptor) {
    super();
    this.#linkInterceptCb = new LinkInterceptCallback(linkInterceptor);
    this.#linkResponseCb = new LinkResponseCallback(linkInterceptor);
  }

  /**
   * Intercepts links clicked within the modal to the given urls.
   * Links are transformed to request the partial content and the content is displayed in the modal.
   * @param  {...any} hrefs the urls to intercept
   */
  handleLinks(...hrefs) {
    // Add `Content` suffix to hrefs to return the partial content and not the whole page.
    const contentHrefs = hrefs.map((href) => `${href}Content`);

    // Add  Content suffix on intercept.
    this.#linkInterceptCb.create("Append 'Content' suffix", (href) => `${href}Content`, ...hrefs);

    // Get the response content and inject it in the modal
    this.#linkResponseCb.create("Set content on load", async ({ href, response }) => {
      await this.setContentOnLoad(response);
    }, ...contentHrefs);
  }

  async open(title) {
    this.#$container = this.#getContentContainer();
    super.setContent(title, this.#$container);

    this.#enableLinkCallbacks();

    await super.open();
  }

  async close() {
    this.#disableLinkCallbacks();
    return super.close();
  }

  onSetContent(callback) {
    this.#setContentCb = callback;
  }

  setContent(newContent) {
    this.#$container.html(newContent);
    // Reparse a new form (if it exists) to apply the validators
    $.validator.unobtrusive.parse("form");
    // Rebind events
    this.#enableLinkCallbacks();
    // Call registered callback
    if (this.#setContentCb) {
      this.#setContentCb();
    }
  }

  async setContentOnLoad(contentPromise) {
    let content;
    try {
      content = await contentPromise;
    } catch (errResp) {
      this.handleContentLoadError(errResp);
    }

    this.setContent(content);
    this.scrollToContent();
  }

  handleContentLoadError(errResp) {
    console.error(errResp);

    // Alert the error and rethrow to stop processing
    const vm = new ViewMessage({
      type: "alert",
      header: "Error",
      body: "There was an error loading the page, please try again later. If this problem persists please contact the practice to report the issue."
    });
    vm.display(this.#$container);

    throw errResp;
  }

  #getContentContainer() {
    return $(`<div id="content" class="row p-3"></div>`);
  }

  #enableLinkCallbacks() {
    this.#linkInterceptCb.enable();
    this.#linkResponseCb.enable();
  }

  #disableLinkCallbacks() {
    this.#linkInterceptCb.disable();
    this.#linkResponseCb.disable();
  }
}
